import Button from 'style-guide/Button';
import SearchDropdown from 'views/SuperAdmin/SearchDropdown';

export const numericTableColumns = () => [
  {
    title: <SearchDropdown title='Question' name='question' placement='bottomLeft' />,
    dataIndex: 'question',
    key: 'question',
    width: 200,
  },
  {
    title: 'Series',
    dataIndex: 'legend',
    key: 'series',
    width: 100,
  },
  {
    title: 'Avg Score',
    dataIndex: 'averagePoint',
    key: 'averagePoint',
    width: 100,
  },
];

export const memberListTableColumns = (setSearchParams) => [
  {
    title: <SearchDropdown title='Member' name='member' placement='bottomLeft' />,
    dataIndex: 'member',
    key: 'member',
  },
  {
    title: 'Completed on',
    dataIndex: 'completedOn',
    key: 'completedOn',
  },
  {
    title: 'Avg Score',
    dataIndex: 'averagePoint',
    key: 'averagePoint',
  },
  // {
  //   title: 'Retakes',
  //   dataIndex: 'retakes',
  //   key: 'retakes',
  // },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    render: (_index, item) => (
      <Button
        variant='link'
        onClick={() => {
          setSearchParams({ userId: item.userId, name: item.userName });
        }}
      >
        View
      </Button>
    ),
  },
];
